import React, {Component} from 'react';
import EmptyComponent from "../../../../../components/empty";
import strings from "../../../../../util/strings";
import {Col} from "reactstrap";
import * as _ from 'lodash';
// import { ChatFeed, Message } from 'react-chat-ui'
// import { GiftedChat } from 'react-gifted-chat';
import {GiftedChat, Send} from 'react-web-gifted-chat'
import "./index.css";
import ChatWindowDateHeader from "../../../../../components/messaging/chat-window-date-header";
import ChatWindowBubble from "../../../../../components/messaging/chat-window-bubble";
import ChatWindowDetailDropdown from "../../../../../components/messaging/chat-window-detail-header";
import UserSection from "../../../../../components/messaging/chat-window-detail-header/user-section";
import sb from "../../../../../util/sendbird";
import utility from "../../../../../util/messaging/utility";
import api from "../../../../../util/messaging/api";
import {connect} from "react-redux";
import * as actions from "../../../../../actions";
import {vuepayAlert} from "../../../../../util/utility";
import assets from "../../../../../util/assets";
import ChatWindowInputToolbar from "../../../../../components/messaging/chat-window-input-toolbar";
import HomeCardComponent from "../../../../../components/clipstore/user/home/card";
import ChatWindowAttachmentInputToolbar from "../../../../../components/messaging/chat-window-attachment-input-toolbar";

const loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum';
const messages = [];
messages.push(generateMessage(`Idylla 2`, 3, {image: 'https://www.wykop.pl/cdn/c3201142/comment_Sc8p2KAVLx3EyNIpXuOXngk3ZYJ0g8eq.jpg'}));
messages.push(generateMessage(`Goood 1`, 2, {image: 'http://img2.dmty.pl//uploads/201010/1286036107_by_julia2332_600.jpg'}));
messages.push(generateMessage(`This is a great example of system message`, 2, {system: true}));

for (let i = 0; i < 30; i++) {
    messages.push(generateMessage(loremIpsum.substring(0, (Math.random() * 100000) % loremIpsum.length), i))
}

function generateMessage(text, index, additionalData) {
    return {
        id: Math.round(Math.random() * 1000000),
        text: text,
        createdAt: new Date(),
        user: {
            id: index % 3 === 0 ? 1 : 2,
            name: 'Johniak',
            avatar: "https://www.pinclipart.com/picdir/middle/555-5557064_happy-vector-free-man-round-avatar-user-icon.png"
        },
        ...additionalData,
    }
}

class MessageDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            sbMessages: [],
            refresh: true,
            selectedIndexOnPreview: 0,
            messageTextPreview: '',
            isSendingMessage: false,
        }
        this.onSend = this.onSend.bind(this)
    }

    setSelectedIndexOnPreview = (selectedIndexOnPreview) => {
        this.setState({
            selectedIndexOnPreview
        })
    }

    postContentInChat = () => {
        let data = {
            posts: [],
            device: this.props.device
        }

        let postArray = [];
        this.props.selectedItems.map((item, index) => {
            let obj = {
                "type": item.type,
                "uuid": item.id,
                "pricing_type": item.price.type,
                "amount": item.price.amount,
            }
            postArray.push(obj);
        })

        if (postArray.length > 0) {
            this.setState({
                isSendingMessage: true
            })
            data["posts"] = postArray;
            api.postContentInChatAPI(this.props, data);
        } else {
            //TODO show error
        }
    }

    attachmentClicked = (currentMessage,clickedContent)=>{
        //TODO user type

        this.props.showLightBox(currentMessage);

        //this is for broadcaster
        let idsArray = [];
        currentMessage.data.map((message,index)=>{
            idsArray.push(message.id);
        })

        api.getChatPostAPI(this.props,{"ids":idsArray,"width":500})
    }

    loadPreviousMessages() {
        if (this.props.selectedChannel !== null) {
            sb.sbLoadPreviousMessage(this.props.selectedChannel, (messages) => {
                let previousMessages = [];

                _.map(messages, (message, index) => {
                    previousMessages.push(utility.generateMessageForGiftChat(message));
                });

                this.setState({
                    messages: this.state.refresh ? previousMessages : this.state.messages.concat(previousMessages),
                    sbMessage: this.state.refresh ? messages : this.state.sbMessage.concat(messages),
                    refresh: false
                }, () => {
                    setTimeout(() => {
                        /** Mark messages as read
                         * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel-advanced#2-mark-messages-as-read
                         */
                        this.props.selectedChannel.markAsRead();
                        //pulled latest messages inform the listing
                        this.props.refreshList();
                    }, 500);
                })
            }, () => {
                //TODO Sangam
            })
        }
    }

    deleteMessageByID = (message) => {
        const payload = {
            image: assets.clipstore.delete_icon,
            title: strings.messaging.delete_message.title,
            description: strings.messaging.delete_message.description
        };
        const isConfirmationModal = true;
        const actionArray = [{
            text: "CANCEL",
            click: () => {
                console.log("Clicked on CANCEL");
                this.props.hideCommonModal()
            }
        }, {
            text: "DELETE",
            click: () => {
                console.log("Clicked on OK")
                const index = _.findIndex(this.state.sbMessage, function (o) {
                    return o.messageId === message.id
                });
                sb.sbDeleteByID(this.props.selectedChannel,this.state.sbMessage[index],()=>{
                    this.setState({
                        refresh:true
                    })
                    this.loadPreviousMessages();
                },(error)=>{
                    console.log("MessageDetail >> deleting a message error >> error = ",error)
                    //TODO
                })
            }
        }];

        this.props.showCommonModal(payload, isConfirmationModal, actionArray);
    }


    renderLoading() {
        return (<div>Loading...</div>)
    }

    onSend(message, data = null) {
        console.log("MessageDetail >> onSend", {
            message,
            data
        })
        sb.sbSendMessage(this.props.selectedChannel,
            message.text,
            data ? JSON.stringify(data) : null,
            [],
            (sbMessage) => {

                this.setState({
                    messageTextPreview:'',
                    isSendingMessage: false,
                    messages: [utility.generateMessageForGiftChat(sbMessage), ...this.state.messages]
                },()=>{
                    this.props.setAttachmentState("selection")
                })

                setTimeout(() => {
                    /** Mark messages as read
                     * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel-advanced#2-mark-messages-as-read
                     */
                    this.props.selectedChannel.markAsRead();
                    //pulled latest messages inform the listing
                    this.props.updateIndividualChannel(this.props.selectedChannel, sbMessage)
                }, 500);
            }, () => {
                //TODO Sangam
            })
    }

    uploadFromPC(props) {
        props.history.push({
            pathname: '/broadcaster/my-library/create',
            state: {
                selectedChannel: props.selectedChannel,
                fromMessageScreen: true
            }
        });
    }

    refreshPage = ()=>{
        this.setState({
            refresh: true
        })
        this.loadPreviousMessages();
    }

    componentDidMount() {
        console.log("MessageDetail >> #################### componentDidMount ####################")
        this.refreshPage();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.selectedChannel !== this.props.selectedChannel) {
            console.log("MessageDetail >> componentDidUpdate >> #################### loadPreviousMessages ####################")
            this.refreshPage();
        }

        //new message received
        if (prevProps.newMessageReceived !== this.props.newMessageReceived &&
            this.props.newMessageReceived.channel &&
            this.props.selectedChannel &&
            this.props.newMessageReceived.channel.url === this.props.selectedChannel.url) {

            let sbMessage = this.props.newMessageReceived.message;
            this.setState({messages: [utility.generateMessageForGiftChat(sbMessage), ...this.state.messages]})
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.availability && nextProps.availability.blockUserSuccess) {
            let message = "User blocked successfully";
            if(nextProps.availability.payload && nextProps.availability.payload.hasOwnProperty("message")){
                message = nextProps.availability.payload.message;
            }
            vuepayAlert("success",message);
            //refreshes the user list from sendbird
            this.props.refreshList();
            //clears the reducer action
            this.props.resetBlockUser();
        } else if (nextProps && nextProps.availability && nextProps.availability.blockUserError) {
            let message = "Sorry we couldn't process your request";
            if (nextProps.availability.payload && nextProps.availability.payload.hasOwnProperty("message")) {
                message = nextProps.availability.payload.message;
            }
            vuepayAlert("error", message);
            //clears the reducer action
            this.props.resetBlockUser();
        }

        if (nextProps && nextProps.post_content_in_chat && nextProps.post_content_in_chat.hasOwnProperty("payload") && nextProps.post_content_in_chat.payload) {
            let payload = nextProps.post_content_in_chat.payload;

            if(payload.hasOwnProperty("success") && payload.success && payload.success.hasOwnProperty("data")){
                let data = payload.success.data;
                this.onSend({text: this.state.messageTextPreview.trim()},data);
            }else{
                //TODO error
            }
            //clears the reducer action
            this.props.resetPostContentInChat();
        }

        if (nextProps && nextProps.get_chat_post && nextProps.get_chat_post.hasOwnProperty("payload") && nextProps.get_chat_post.payload) {
            let payload = nextProps.get_chat_post.payload;

            if(payload.hasOwnProperty("success") && payload.success && payload.success.hasOwnProperty("data")){
                let data = payload.success.data;
                console.log("fetched details.....", data)
                this.props.setFullData(data)
                this.props.setLightBoxData(utility.getLightBoxData(data))
            } else {
                //TODO error
            }
            //clears the reducer action
            this.props.resetPostContentInChat();
        }
    }

    renderSend(props) {
        return (
            <Send{...props}>
                <div className="display-flex">
                    <img src={assets.group_icon_blue_bg} onClick={() => {
                        console.log("circle image")
                    }}/>
                    <img src={assets.is_favourite_circle} onClick={() => {
                        console.log("heart image")
                    }}/>
                    <div>Send</div>
                </div>
            </Send>
        );
    }

    renderEmptyComponent = () => {
        return (
            <Col md="8">
                <EmptyComponent
                    img={strings.messaging.nothing_selected.image}
                    title={strings.messaging.nothing_selected.title}
                    description={strings.messaging.nothing_selected.description}
                    btnAction={this.newChat}
                    btnText={strings.messaging.nothing_selected.btnText}
                />
            </Col>
        );
    }

    renderChatComponent = () => {
        return (
            <Col md="8">

                <div className="direct-messaging-detail-container">
                    <div className="direct-messaging-detail-container-chat">
                        <div className="display-flex-align-center direct-messaging-detail-header">
                            <UserSection
                                user={this.props.user}
                                broadcaster={this.props.broadcaster}
                                user_type={this.props.user_type}
                                selectedChannel={this.props.selectedChannel}
                            />
                            <ChatWindowDetailDropdown
                                {...this.props}
                                broadcaster={this.props.broadcaster}
                                selectedChannel={this.props.selectedChannel}
                                history={this.props.history}
                                archive={() => {
                                    sb.sbArchive(this.props.selectedChannel, () => {
                                        this.props.fetchGroupChannels();
                                    }, () => {
                                        //TODO Sangam
                                    });
                                }}
                                isFetching={this.props.availability.isFetching}
                            />
                        </div>
                        <div className="direct-messaging-detail-giftchat-container">
                            <GiftedChat
                                user={{id: sb.getCurrentUserID(),}}
                                renderBubble={(props) => <ChatWindowBubble {...props} deleteMessageByID={this.deleteMessageByID} attachmentClicked={this.attachmentClicked}/>}
                                renderAvatar={null}
                                renderDay={(props) => {
                                    return (
                                        <ChatWindowDateHeader
                                            inverted={props.inverted}
                                            currentMessage={props.currentMessage}
                                            nextMessage={props.nextMessage}
                                            previousMessage={props.previousMessage}/>
                                    )
                                }}
                                messages={this.state.messages}
                                renderInputToolbar={() => {
                                    return (
                                        <ChatWindowInputToolbar
                                            text={''}
                                            uploadFromPC={() => {
                                                this.uploadFromPC(this.props)
                                            }}
                                            onSend={this.onSend}
                                            broadcaster={this.props.broadcaster}
                                            setAttachmentModal={this.props.setAttachmentModal}
                                        />
                                    )
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Col>
        );
    }

    renderPreviewComponent = () => {
        return (
            <Col md="8">
                <div className="direct-messaging-detail-container">
                    <div className="direct-messaging-detail-container-chat">
                        <div className="display-flex-align-center direct-messaging-detail-header">
                            <UserSection
                                user={this.props.user}
                                broadcaster={this.props.broadcaster}
                                user_type={this.props.user_type}
                                selectedChannel={this.props.selectedChannel}
                            />
                            <ChatWindowDetailDropdown
                                {...this.props}
                                broadcaster={this.props.broadcaster}
                                selectedChannel={this.props.selectedChannel}
                                history={this.props.history}
                                archive={() => {
                                    sb.sbArchive(this.props.selectedChannel, () => {
                                        this.props.fetchGroupChannels();
                                    }, () => {
                                        //TODO Sangam
                                    });
                                }}
                                isFetching={this.props.availability.isFetching}
                            />
                        </div>
                        <div className="direct-messaging-preview">
                            <div className="direct-messaging-preview-header">
                                <img src={assets.messaging.preview.white_cross}
                                     alt={"messaging preview cross"}
                                     onClick={() => {
                                         this.props.setAttachmentState("selection")
                                     }}/>
                                <span className="direct-messaging-preview-title">Preview</span>
                            </div>
                            <div className="direct-messaging-preview-body">
                                <HomeCardComponent
                                    openBroadcasterProfile={() => {
                                    }}
                                    hideTitle
                                    containerClassName={"home-container-list-item-container-for-preview-body"}
                                    imgLoadingContainer={"home-container-list-item-img-for-preview-body"}
                                    imgContainerClassName={"home-container-list-item-img-container-for-preview-body"}
                                    showBroadcasterSection={false}
                                    selectCard={(content) => {
                                        console.log("selectCard", content)
                                    }}
                                    openDetail={() => {
                                    }}
                                    content={this.props.selectedItems[this.state.selectedIndexOnPreview]}
                                    key={`home-container-list-item-container-for-preview-body-${this.state.selectedIndexOnPreview}`}
                                />

                                <div className="direct-messaging-preview-body-message-container">
                                    <div className="direct-messaging-preview-body-message-text">Write something here....
                                    </div>
                                    <ChatWindowAttachmentInputToolbar
                                        onSend={this.postContentInChat}
                                        setText={(text) => {
                                            this.setState({
                                                messageTextPreview: text
                                            },()=>{
                                                console.log("MessageDetail >> messageTextPreview",this.state.messageTextPreview)
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="direct-messaging-preview-send">
                                {
                                    this.state.isSendingMessage
                                        ?
                                        <img src={assets.loading_white} alt={"loading"} width={28}/>
                                        :
                                        <img src={assets.messaging.preview.white_send}
                                             alt={"send"}
                                             width={28}
                                             className="cursor-pointer" onClick={this.postContentInChat}/>
                                }
                            </div>
                            <div className="direct-messaging-preview-footer">
                                {
                                    this.props.selectedItems.map((content, index) => {
                                        return (
                                            <HomeCardComponent
                                                openBroadcasterProfile={() => {
                                                }}
                                                hideTitle
                                                containerClassName={"home-container-list-item-container-for-preview"}
                                                imgLoadingContainer={"home-container-list-item-img-for-preview"}
                                                imgContainerClassName={"home-container-list-item-img-container-for-preview"}
                                                showBroadcasterSection={false}
                                                selectCard={(content) => {

                                                }}
                                                openDetail={(content) => {
                                                    console.log("openDetail", content)
                                                    const index = _.findIndex(this.props.selectedItems, function (o) {
                                                        return o.id === content.id
                                                    });
                                                    this.setSelectedIndexOnPreview(index);
                                                }}
                                                content={content}
                                                key={`home-container-list-item-container-for-preview-${index}`}
                                            />
                                        )
                                    })
                                }
                                {
                                    this.props.selectedItems.length < 5 &&
                                    <div className="direct-messaging-preview-footer-add-file-container"
                                         onClick={() => {
                                             this.props.setAttachmentModal(true);
                                         }}>
                                        <img src={assets.messaging.preview.white_plus} alt={"plus icon"}/>
                                        <span>ADD FILE</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        );
    }

    render() {
        if (this.props.selectedChannel === null) {
            return this.renderEmptyComponent();
        } else if (this.props.attachmentState === "preview") {
            return this.renderPreviewComponent();
        } else {
            return this.renderChatComponent();
        }
    }
}

MessageDetail.propTypes = {};


function mapStateToProps(state, ownParams) {
    return {
        availability: state.availability,
        device: state.device.payload,
        post_content_in_chat: state.post_content_in_chat,
        get_chat_post:state.get_chat_post
    };
}

export default connect(mapStateToProps, actions)(MessageDetail);
